/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 */
const { addLocaleData } = require('react-intl');
const enLocaleData = require('react-intl/locale-data/en');
const nlLocaleData = require('react-intl/locale-data/nl');
// const beLocaleData = require('react-intl/locale-data/be');
// const sgLocaleData = require('react-intl/locale-data/sg');
const deLocaleData = require('react-intl/locale-data/de');
const idLocaleData = require('react-intl/locale-data/id');
const zhLocaleData = require('react-intl/locale-data/zh');
const msLocaleData = require('react-intl/locale-data/ms');
const ptLocaleData = require('react-intl/locale-data/pt');
const hrLocaleData = require('react-intl/locale-data/hr');
const esLocaleData = require('react-intl/locale-data/es');
const frLocaleData = require('react-intl/locale-data/fr');
const itLocaleData = require('react-intl/locale-data/it');
const elLocaleData = require('react-intl/locale-data/el');
const plLocaleData = require('react-intl/locale-data/pl');
const fiLocaleData = require('react-intl/locale-data/fi');

const benlTranslationMessages = require('./translations/nl-be.json');
const nlnlTranslationMessages = require('./translations/nl-nl.json');
const sgenTranslationMessages = require('./translations/en-sg.json');
const enbeTranslationMessages = require('./translations/en-be.json');
const dedeTranslationMessages = require('./translations/de-de.json');
const ididTranslationMessages = require('./translations/id-id.json');
const zhcnTranslationMessages = require('./translations/zh-cn.json');
const msmyTranslationMessages = require('./translations/ms-my.json');
const ptptTranslationMessages = require('./translations/pt-pt.json');
const hrhrTranslationMessages = require('./translations/hr-hr.json');
const esesTranslationMessages = require('./translations/es-es.json');
const esmxTranslationMessages = require('./translations/es-mx.json');
const frfrTranslationMessages = require('./translations/fr-fr.json');
const frbeTranslationMessages = require('./translations/fr-be.json');
const ititTranslationMessages = require('./translations/it-it.json');
const elgrTranslationMessages = require('./translations/el-gr.json');
const plplTranslationMessages = require('./translations/pl-pl.json');
const fifiTranslationMessages = require('./translations/fi-fi.json');

const APP_LOCALES = {
  NL_BE: 'nl-be',
  NL_NL: 'nl-nl',
  EN_SG: 'en-sg',
  EN_BE: 'en-be',
  DE_DE: 'de-de',
  ID_ID: 'id-id',
  MS_MY: 'ms-my',
  PT_PT: 'pt-pt',
  ZH_CN: 'zh-cn',
  HR_HR: 'hr-hr',
  ES_ES: 'es-es',
  ES_MX: 'es-mx',
  FR_FR: 'fr-fr',
  FR_BE: 'fr-be',
  IT_IT: 'it-it',
  EL_GR: 'el-gr',
  PL_PL: 'pl-pl',
  FI_FI: 'fi-fi'
};

const DEFAULT_LOCALE = APP_LOCALES.EN_BE;
const appLocales = [
  APP_LOCALES.NL_BE,
  APP_LOCALES.NL_NL,
  APP_LOCALES.EN_SG,
  APP_LOCALES.EN_BE,
  APP_LOCALES.DE_DE,
  APP_LOCALES.ID_ID,
  APP_LOCALES.MS_MY,
  APP_LOCALES.PT_PT,
  APP_LOCALES.ZH_CN,
  APP_LOCALES.HR_HR,
  APP_LOCALES.ES_ES,
  APP_LOCALES.ES_MX,
  APP_LOCALES.FR_FR,
  APP_LOCALES.FR_BE,
  APP_LOCALES.IT_IT,
  APP_LOCALES.EL_GR,
  APP_LOCALES.PL_PL,
  APP_LOCALES.FI_FI
];

addLocaleData(enLocaleData);
addLocaleData(nlLocaleData);
addLocaleData(deLocaleData);
addLocaleData(idLocaleData);
addLocaleData(zhLocaleData);
addLocaleData(msLocaleData);
addLocaleData(ptLocaleData);
addLocaleData(hrLocaleData);
addLocaleData(esLocaleData);
addLocaleData(frLocaleData);
addLocaleData(itLocaleData);
addLocaleData(elLocaleData);
addLocaleData(plLocaleData);
addLocaleData(fiLocaleData);

const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, benlTranslationMessages)
      : {};
  return Object.keys(messages).reduce((formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  }, {});
};

const translationMessages = {
  [APP_LOCALES.NL_BE]: formatTranslationMessages(
    APP_LOCALES.NL_BE,
    benlTranslationMessages
  ),
  [APP_LOCALES.NL_NL]: formatTranslationMessages(
    APP_LOCALES.NL_NL,
    nlnlTranslationMessages
  ),
  [APP_LOCALES.EN_SG]: formatTranslationMessages(
    APP_LOCALES.EN_SG,
    sgenTranslationMessages
  ),
  [APP_LOCALES.EN_BE]: formatTranslationMessages(
    APP_LOCALES.EN_BE,
    enbeTranslationMessages
  ),
  [APP_LOCALES.DE_DE]: formatTranslationMessages(
    APP_LOCALES.DE_DE,
    dedeTranslationMessages
  ),
  [APP_LOCALES.ID_ID]: formatTranslationMessages(
    APP_LOCALES.ID_ID,
    ididTranslationMessages
  ),
  [APP_LOCALES.ZH_CN]: formatTranslationMessages(
    APP_LOCALES.ZH_CN,
    zhcnTranslationMessages
  ),
  [APP_LOCALES.MS_MY]: formatTranslationMessages(
    APP_LOCALES.MS_MY,
    msmyTranslationMessages
  ),
  [APP_LOCALES.PT_PT]: formatTranslationMessages(
    APP_LOCALES.PT_PT,
    ptptTranslationMessages
  ),
  [APP_LOCALES.HR_HR]: formatTranslationMessages(
    APP_LOCALES.HR_HR,
    hrhrTranslationMessages
  ),
  [APP_LOCALES.ES_ES]: formatTranslationMessages(
    APP_LOCALES.ES_ES,
    esesTranslationMessages
  ),
  [APP_LOCALES.ES_MX]: formatTranslationMessages(
    APP_LOCALES.ES_MX,
    esmxTranslationMessages
  ),
  [APP_LOCALES.FR_FR]: formatTranslationMessages(
    APP_LOCALES.FR_FR,
    frfrTranslationMessages
  ),
  [APP_LOCALES.FR_BE]: formatTranslationMessages(
    APP_LOCALES.FR_BE,
    frbeTranslationMessages
  ),
  [APP_LOCALES.IT_IT]: formatTranslationMessages(
    APP_LOCALES.IT_IT,
    ititTranslationMessages
  ),
  [APP_LOCALES.EL_GR]: formatTranslationMessages(
    APP_LOCALES.EL_GR,
    elgrTranslationMessages
  ),
  [APP_LOCALES.PL_PL]: formatTranslationMessages(
    APP_LOCALES.PL_PL,
    plplTranslationMessages
  ),
  [APP_LOCALES.FI_FI]: formatTranslationMessages(
    APP_LOCALES.FI_FI,
    fifiTranslationMessages
  )
};

module.exports = {
  APP_LOCALES,
  appLocales,
  formatTranslationMessages,
  translationMessages
};



// WEBPACK FOOTER //
// ./src/i18n.js